import React from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { deliveryErrorMessageKey } from './deliveryStatusPresentation'

/**
 * Story 175, S134 (RN56) -- the counters could not be read: their place shows the translated error with
 * Retry, and no pill is painted (nothing to press). The details table keeps working on its own; if a status
 * filter was already active, "Clear filter" stays reachable here (its usual row lives with the pills).
 */
const DeliveryCountersError = ({ error, onRetry, filterActive = false, onClearFilter = () => {} }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Alert
      severity='warning'
      variant='outlined'
      sx={{ marginBottom: 1 }}
      data-testid='delivery-counters-error'
      action={(
        <>
          {filterActive ? <Button color='inherit' size='small' onClick={onClearFilter}>{t_('Clear filter')}</Button> : null}
          <Button color='inherit' size='small' onClick={onRetry}>{t_('Retry')}</Button>
        </>
      )}
    >
      {t_(deliveryErrorMessageKey(error))}
    </Alert>
  )
}

export default DeliveryCountersError
